import React from 'react';

import { LayerBranch } from './components/LayerBranch';

import styles from './LayersTree.module.scss';

const LayersTree = ({
  readOnly,
  data,
  namePrefix,
  currentLayer,
  onLayerCheckChanged,
  onLayerClick,
}: {
  readOnly: any;
  data: any;
  namePrefix: any;
  currentLayer: any;
  onLayerCheckChanged: any;
  onLayerClick: any;
}) => {
  return (
    <div className={styles.tree}>
      {data.map((layer: any, layerIndex: any) => (
        <LayerBranch
          key={layer.id}
          readOnly={readOnly}
          layer={layer}
          currentLayer={currentLayer}
          namePrefix={`${namePrefix}[${layerIndex}]`}
          level={0}
          onLayerCheckChanged={onLayerCheckChanged}
          onLayerClick={onLayerClick}
        />
      ))}
    </div>
  );
};

export default React.memo(LayersTree) as any;
